import React from "react";

interface IconProps {
	className?: string;
	size?: number;
}

const StarIcon: React.FC<IconProps> = ({ className = "", size = 20 }) => {
	return (
		<svg
			width={size}
            height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
            className={className}
		>
			<g clipPath="url(#clip0_2905_2841)">
				<path
					d="M19.4413 9.48945C19.9481 8.99566 20.127 8.27093 19.9082 7.59843C19.6899 6.92566 19.1192 6.44453 18.4189 6.34277L14.0952 5.71453C13.8757 5.6825 13.6861 5.54472 13.588 5.34597L11.6543 1.42769C11.3413 0.793512 10.7073 0.399567 9.99996 0.399567C9.29262 0.399567 8.65868 0.793512 8.34559 1.42769L6.41196 5.34593C6.31383 5.54476 6.12418 5.68254 5.90504 5.71449L1.58106 6.34273C0.880748 6.44453 0.310084 6.92566 0.0918414 7.59808C-0.127026 8.27093 0.0518414 8.9957 0.558521 9.48933L3.68735 12.5395C3.84606 12.6941 3.91848 12.9169 3.8811 13.1352L3.14235 17.4419C3.02297 18.1392 3.30418 18.8305 3.87626 19.2461C4.44844 19.6618 5.19297 19.7157 5.81938 19.3867L9.68664 17.3534C9.88282 17.2503 10.1171 17.2503 10.3131 17.3533L14.1806 19.3867C14.807 19.7157 15.5516 19.6618 16.1238 19.2461C16.6958 18.8305 16.977 18.1392 16.8577 17.4419L16.1189 13.1353C16.0815 12.9169 16.1539 12.6941 16.3127 12.5394L19.4413 9.48945Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2905_2841">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default StarIcon;
